var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uploadImg"},[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":_vm.action,"data":_vm.data,"show-file-list":false,"on-success":_vm.handleAvatarSuccess,"before-upload":_vm.beforeAvatarUpload}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }